var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMove = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 47 12"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "ic-move_svg__a",
  width: 4,
  height: 10,
  x: 0,
  y: 2,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M.46 2.771v8.458c0 .147.12.267.267.267h2.96c.147 0 .266-.12.266-.267V2.77z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ic-move_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF8ADC",
  fillRule: "evenodd",
  d: "M.46 2.771v8.458c0 .147.12.267.267.267h2.96c.147 0 .266-.12.266-.267V2.77z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "ic-move_svg__b",
  width: 4,
  height: 10,
  x: 9,
  y: 2,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M9.297 2.771v8.458c0 .147.12.267.267.267h2.959c.147 0 .266-.12.266-.267V2.77z",
  clipRule: "evenodd"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ic-move_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF8ADC",
  fillRule: "evenodd",
  d: "M9.297 2.771v8.458c0 .147.12.267.267.267h2.959c.147 0 .266-.12.266-.267V2.77z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "ic-move_svg__c",
  width: 12,
  height: 12,
  x: 14,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M20.048.462c-3.252 0-5.8 2.46-5.8 5.602v.03a5.47 5.47 0 0 0 1.646 3.948c1.071 1.047 2.536 1.624 4.124 1.624 3.253 0 5.8-2.46 5.8-5.602v-.03a5.47 5.47 0 0 0-1.645-3.948C23.1 1.038 21.636.462 20.048.462m-2.446 5.602v-.03c0-1.464 1.04-2.568 2.417-2.568 1.402 0 2.46 1.117 2.46 2.598v.03c0 1.464-1.045 2.568-2.43 2.568-1.372 0-2.447-1.141-2.447-2.598",
  clipRule: "evenodd"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ic-move_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF8ADC",
  fillRule: "evenodd",
  d: "M20.048.462c-3.252 0-5.8 2.46-5.8 5.602v.03a5.47 5.47 0 0 0 1.646 3.948c1.071 1.047 2.536 1.624 4.124 1.624 3.253 0 5.8-2.46 5.8-5.602v-.03a5.47 5.47 0 0 0-1.645-3.948C23.1 1.038 21.636.462 20.048.462m-2.446 5.602v-.03c0-1.464 1.04-2.568 2.417-2.568 1.402 0 2.46 1.117 2.46 2.598v.03c0 1.464-1.045 2.568-2.43 2.568-1.372 0-2.447-1.141-2.447-2.598",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "ic-move_svg__d",
  width: 12,
  height: 12,
  x: 25,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M33.791.67a.46.46 0 0 0-.433.305L31.306 6.7c-.016.046-.081.046-.098 0L29.156.975a.46.46 0 0 0-.433-.306H26.07a.46.46 0 0 0-.428.634l3.998 9.94c.07.176.238.29.427.29h2.319a.46.46 0 0 0 .427-.29l3.998-9.94a.46.46 0 0 0-.427-.634z",
  clipRule: "evenodd"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ic-move_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF8ADC",
  fillRule: "evenodd",
  d: "M33.791.67a.46.46 0 0 0-.433.305L31.306 6.7c-.016.046-.081.046-.098 0L29.156.975a.46.46 0 0 0-.433-.306H26.07a.46.46 0 0 0-.428.634l3.998 9.94c.07.176.238.29.427.29h2.319a.46.46 0 0 0 .427-.29l3.998-9.94a.46.46 0 0 0-.427-.634z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "ic-move_svg__e",
  width: 10,
  height: 12,
  x: 37,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M38.182.67a.46.46 0 0 0-.46.46v9.867c0 .255.206.462.46.462h7.896c.254 0 .46-.207.46-.462V9.064a.46.46 0 0 0-.46-.461h-5.053a.05.05 0 0 1-.053-.053V7.418c0-.029.024-.052.053-.052h4.461c.254 0 .46-.207.46-.462V5.15a.46.46 0 0 0-.46-.461h-4.461a.05.05 0 0 1-.053-.052V3.577c0-.028.024-.052.053-.052h4.98c.253 0 .46-.207.46-.461V1.13a.46.46 0 0 0-.46-.462z",
  clipRule: "evenodd"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ic-move_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF8ADC",
  fillRule: "evenodd",
  d: "M38.182.67a.46.46 0 0 0-.46.46v9.867c0 .255.206.462.46.462h7.896c.254 0 .46-.207.46-.462V9.064a.46.46 0 0 0-.46-.461h-5.053a.05.05 0 0 1-.053-.053V7.418c0-.029.024-.052.053-.052h4.461c.254 0 .46-.207.46-.462V5.15a.46.46 0 0 0-.46-.461h-4.461a.05.05 0 0 1-.053-.052V3.577c0-.028.024-.052.053-.052h4.98c.253 0 .46-.207.46-.461V1.13a.46.46 0 0 0-.46-.462z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "ic-move_svg__f",
  width: 13,
  height: 11,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M.46.642H12.79v10.324H.461z",
  clipRule: "evenodd"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ic-move_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF29BF",
  fillRule: "evenodd",
  d: "M11.926 1.076a2.16 2.16 0 0 0-3 .398L6.624 4.445l-2.3-2.97a2.16 2.16 0 0 0-3.002-.399 2.166 2.166 0 0 0-.405 3.062l5.044 6.504a.838.838 0 0 0 1.325 0l5.044-6.504a2.166 2.166 0 0 0-.405-3.062",
  clipRule: "evenodd"
}))));
export default SvgIcMove;